<div class="chat_buttons pointer" *ngIf="!isMobile && accessToken" (click)="openChat()">
  <div class="chat_icon" [ngClass]="{have_notification_state: badgesCount > 0}">
    <img [src]="badgesCount > 0? 'assets/images/icons/chat/chat-notification.svg' : 'assets/images/icons/chat/chat.svg'">
    <div *ngIf="badgesCount > 0" class="ml_8 have_notification_text">
      У вас новое сообщение!
    </div>
  </div>
</div>
